import React from 'react';
import { Icon } from '@iconify/react';

export default function AccessDenied() {
  return (
    <div className="flex-1 flex items-center justify-center p-8">
      <div className="text-center space-y-4 max-w-sm">
        <div className="w-16 h-16 bg-destructive/10 rounded-2xl flex items-center justify-center mx-auto">
          <Icon icon="lucide:shield-off" className="text-3xl text-destructive" />
        </div>
        <div>
          <h2 className="text-xl font-heading font-bold">Access Denied</h2>
          <p className="text-sm text-muted-foreground mt-2">
            You don't have permission to view this page. Contact your super admin to request access.
          </p>
        </div>
      </div>
    </div>
  );
}
